import {ExtraInfoLayout, LogInPageHeroFigure} from "@khan/auth-shared";
import {PermissionsInfo} from "@khan/shared-core";
import {isKhanAcademyUrl, useLocation} from "@khan/urls";

import {LogInForm} from "./log-in-form.tsx";
import {loggedInRedirect} from "./logged-in-redirect.tsx";

interface Props {
    signupComponent?: React.ReactNode;
}

/**
 * A page to allow the user to log in via any method of their choice.
 * This includes email/password, Google, Facebook, Apple, and Clever
 */
const LogIn = ({signupComponent}: Props) => {
    const {queryParams} = useLocation();

    // If the user is already logged in, redirect them to continue URL or
    // the homepage if there is none.
    if (PermissionsInfo.isLoggedIn) {
        const continueUrl = isKhanAcademyUrl(queryParams.continue || "")
            ? queryParams.continue
            : "/";
        return loggedInRedirect(continueUrl);
    }

    return (
        <ExtraInfoLayout
            leftComponent={<LogInPageHeroFigure />}
            rightComponent={
                <LogInForm iconOnly={true} signupComponent={signupComponent} />
            }
        />
    );
};

export default LogIn;
